import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "@tanstack/react-query"
import { Layers, Briefcase, Users, Quote, Newspaper, Mail } from "lucide-react"
import { api, type DashboardCounts } from "@/lib/api"

export const Route = createFileRoute("/admin/_authed/dashboard")({
  component: Dashboard,
})

const cards = [
  { key: "services", label: "Services", icon: Layers },
  { key: "portfolio_items", label: "Portfolio Items", icon: Briefcase },
  { key: "team_members", label: "Team Members", icon: Users },
  { key: "testimonials", label: "Testimonials", icon: Quote },
  { key: "blog_posts", label: "Blog Posts", icon: Newspaper },
  { key: "unread_messages", label: "Unread Messages", icon: Mail },
] as const

function Dashboard() {
  const { data, isLoading, isError } = useQuery<DashboardCounts>({
    queryKey: ["admin", "dashboard"],
    queryFn: async () => (await api.get<DashboardCounts>("/admin/dashboard")).data,
  })

  return (
    <div>
      <h1 className="font-display text-3xl font-bold">Dashboard</h1>
      <p className="mt-1 text-sm text-muted-foreground">Overview of your site content.</p>

      {isError ? (
        <p className="mt-8 text-sm text-destructive">Couldn't load dashboard stats.</p>
      ) : (
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c) => (
            <div key={c.key} className="rounded-2xl border border-border bg-card p-6">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-ink text-cream">
                <c.icon className="h-5 w-5" />
              </div>
              <p className="mt-4 text-3xl font-bold">
                {isLoading ? <span className="inline-block h-8 w-12 animate-pulse rounded bg-secondary" /> : data?.[c.key]}
              </p>
              <p className="mt-1 text-sm text-muted-foreground">{c.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
